import React, { Component } from 'react';
import { Grid, Row, Col, ButtonToolbar, Button, FormGroup, ControlLabel, FormControl, Checkbox, Label, Radio, HelpBlock, Tabs, Tab } from 'react-bootstrap';
import { Table, InputGroup } from 'react-bootstrap';
import { Stage, Layer, Group, Rect, Line, Text } from 'react-konva';
import { LoadingSpinner } from '../../LoadingSpinner';
import { TableButton } from '../../TableButton';
import { ImageCommand } from '../commands/ImageCommand';
import { RegionsCommand } from '../../bussched/commands/RegionsCommand';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { TextOptionsPickerModal } from './TextOptionsPickerModal';
import Select from "react-select";

export class StopsListDataIdentifierCommonForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                id: 0,
                url: "",
                rotationAngle: 0,
                opacity: 1,
                file: null
            },
            styles: {
                text: null,
                rotationAngle: null,
                opacity: null
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
            commands: {
                regions: new RegionsCommand(),
            },
            actions: {
                isLoading: false,
                isSaving: false,
                isDeleting: false
            },
            showValidation: false,
            addSpacerStops: false,
            highlightComplementaryTerminals: false,
            stretchSpine: false,
            configuration: [],
            zonesConfig: {
                zonesPosition: "left",
                zones: [],
                zonesBackgroundBuilderComponent: 0
            },
            allZones: [],
            descriptionOptions: {
                show: false,
                options: [
                    "lineCode",
                    "lineName",
                    "directionIdaVolta",
                    "directionAscDesc",
                    "directionAscDescShort",
                    "directionGoReturnShort"
                ]
            },
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            const { table, actions } = this.state;

            actions.isLoading = true;
            table.data = [];

            this.setState({
                table: table,
                actions: actions
            });
        }

        const imageCommand = new ImageCommand();
        imageCommand.getAll(
            (a) => this.getAllSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );
    }

    // ----------------------------

    componentDidMount() {
        const { configuration } = this.props;

        if (configuration && configuration.length > 0) {
            try {
                let zonesConfig = JSON.parse(configuration);

                while (zonesConfig.zonesConfig) {
                    zonesConfig = zonesConfig.zonesConfig;
                }

                this.props.onChangeZonesValue(zonesConfig);
                this.getZones(zonesConfig);
                return;
            } catch (e) {
                console.error("Failed to parse configuration", e);
            }
        }

        this.getZones();
    }

    getZones(existingZonesConfig) {
        const regionsCommand = new RegionsCommand();

        regionsCommand.list(
            (zones) => {
                existingZonesConfig = existingZonesConfig || {};

                const zonesConfig = {
                    ...existingZonesConfig,
                    zones: existingZonesConfig.zones !== undefined ? existingZonesConfig.zones : [],
                    zonesPosition: existingZonesConfig.zonesPosition !== undefined ? existingZonesConfig.zonesPosition : "left",
                    zonesBackgroundBuilderComponent: existingZonesConfig.zonesBackgroundBuilderComponent !== undefined
                        ? existingZonesConfig.zonesBackgroundBuilderComponent
                        : 0
                };

                this.setState({
                    zonesConfig,
                    allZones: zones
                }, () => {
                    this.props.onChangeZonesValue(zonesConfig);
                });
            },
            (error) => {
                console.error("Failed to load regions", error);
            }
        );
    }

    listDependenciesSuccessCallback(result, updateData, updateAction, callback) {
        const { dependencies, actions } = this.state;

        actions[updateAction] = false;
        dependencies[updateData] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listDependenciesErrorCallback(messageReceived, updateData, updateAction) {
        const { dependencies, actions, message } = this.state;

        actions[updateAction] = false;
        dependencies[updateData] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------------

    onChangeValue(e, target) {
        const { formData } = this.state;
        formData[target] = e.target.value;
        if ("url" === target) {
            formData.file = null;
        }

        this.setState({
            formData: formData
        });
    }

    onChangeFile(event) {
        const { formData } = this.state;

        const uploadedFile = event.target.files[0];

        if (undefined !== uploadedFile) {
            formData.url = uploadedFile.name;
            formData.file = uploadedFile;

            this.setState({
                formData: formData
            });

            // Reset the input file value
            event.target.value = "";
        }
    }

    // -----------------------

    onSelectValue = (selected, target) => {
        if (target === "zones") {
            const updatedZonesConfig = {
                ...this.props.form.zonesConfig,
                zones: selected
            };

            this.props.onChangeZonesValue(updatedZonesConfig);
        }
    };

    handleDescriptionOptionsClick() {
        const { descriptionOptions } = this.state;

        descriptionOptions.show = true;

        this.setState({
            descriptionOptions: descriptionOptions
        });
    }

    onExitDescriptionOptions() {
        const { descriptionOptions } = this.state;

        descriptionOptions.show = false;

        this.setState({
            descriptionOptions: descriptionOptions
        });
    }

    onSelectDescriptionOption(value) {
        const { form } = this.props;
        const newText = (form.descriptionOutsideSpine || "") + value;

        this.props.onChangeValue({ target: { value: newText } }, "descriptionOutsideSpine");

        this.onExitDescriptionOptions();
    }

    onDeleteData(formData) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a imagem "${formData.url}"?`,
                style: "warning",
                icon: "alert",
                argument: {
                    textId: formData.id
                }
            }
        });
    }

    onAddData() {
        const { formData } = this.state;

        let styles = {
            url: null,
            rotationAngle: null,
            opacity: null
        }

        if (0 >= formData.url.length) {
            styles.url = "error"
        }
        if (0 >= formData.rotationAngle.length || -360 > formData.rotationAngle || 360 < formData.rotationAngle) {
            styles.rotationAngle = "error"
        }
        if (0 >= formData.opacity.length || 0 > formData.opacity || 1 < formData.opacity) {
            styles.opacity = "error"
        }

        this.setState({
            styles: styles
        });

        if (null === styles.url && null === styles.rotationAngle && null === styles.opacity) {
            const imageCommand = new ImageCommand();
            imageCommand.save(
                formData,
                (a) => this.saveSuccessCallback(a),
                (a) => this.operationsErrorCallback(a)
            );
        }
    }

    onFileUploadButtonClick() {
        this.refs.imageUploader.click();
    }

    // ---------------------------

    getAllSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    saveSuccessCallback(result) {
        const { actions } = this.state;

        const dataIdStr = `${result.id}`;
        actions.isSaving = false;

        this.setState({
            selectedData: dataIdStr,
            actions: actions,
            formData: {
                id: 0,
                url: "",
                rotationAngle: 0,
                opacity: 1,
            },
            message: {
                show: true,
                message: "Imagem criada com sucesso",
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getAllData(true);

        if (this.props.onAddImage) {
            this.props.onAddImage(dataIdStr);
        }
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            actions.isDeleting = true;

            const imageCommand = new ImageCommand();
            imageCommand.delete(
                argument.textId,
                (a) => this.deleteSuccessCallback(a),
                (a) => this.operationsErrorCallback(a)
            );
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // -----------------------

    selectedData(obj) {
        const selectedData = `${this.props.selectedData}`;
        const isSelected = `${obj.id}` === selectedData;

        if (isSelected) {
            return (
                <h5>
                    <Label bsStyle="success" className="icon-ok icon-img" style={{ cursor: "pointer" }}
                        onClick={() => this.props.onSelectImage(null)}
                    > &nbsp;
                    </Label>
                </h5>
            );
        } else {
            return (
                <TableButton icon="icon-select" title="Selecionar" onClick={() => this.props.onSelectImage(obj.id)} />
            );
        }
    }

    onDialogConfirm() {
        const { dialog, actions } = this.state;

        if (undefined !== dialog.argument && undefined !== dialog.argument.textId) {
            actions.isDeleting = true;

            this.setState({
                actions: actions,
                dialog: {
                    show: false,
                    title: undefined,
                    message: undefined,
                    style: undefined,
                    icon: undefined,
                    argument: undefined
                }
            });

            // Call the API to delete the image
            const imageCommand = new ImageCommand();
            imageCommand.delete(
                dialog.argument.textId,
                (a) => this.deleteSuccessCallback(a),
                (a) => this.operationsErrorCallback(a)
            );
        }
    }

    deleteSuccessCallback(message) {
        const { actions } = this.state;

        actions.isDeleting = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getAllData(true);
    }

    listErrorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.page = 1;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationsErrorCallback(message) {
        const { actions } = this.state;

        actions.isSaving = false;
        actions.isDeleting = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });

        this.getAllData(true);
    }

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        table.elementsPerPage = elementsPerPage;
        table.page = 1;

        this.setState({
            table: table
        });
    }

    handleZonesPositionChange(newPosition) {
        const updatedZonesConfig = {
            ...this.props.form.zonesConfig,
            zonesPosition: newPosition
        };

        this.props.onChangeZonesValue(updatedZonesConfig);
    };

    handleZoneExclusionsChange(excludedZones) {
        const { allZones } = this.state;

        const zonesToUse = allZones.filter(zone => !excludedZones.some(ex => ex.id === zone.id));

        const updatedZonesConfig = {
            ...this.props.form.zonesConfig,
            zones: zonesToUse
        };

        this.props.onChangeZonesValue(updatedZonesConfig);
    };

    // ----------------------------------

    renderStopTextConfigurationsForm(form) {
        if (form.showOnlyInSpineStops) {
            return null;
        }

        return (
            <div>
                <ControlLabel className="margin-top-15">Estratégias para esconder paragens (caso necessário)</ControlLabel>
                <Grid fluid>
                    <FormGroup className="margin-top--10">
                        <Checkbox className="margin-left-15"
                            checked={form.hideNonInSpineStops}
                            onChange={() => this.props.onChangeCheckboxValue("hideNonInSpineStops")}>
                            Esconder paragens não configuradas como presentes na espinha
                        </Checkbox>
                        <Checkbox className="margin-left-15"
                            checked={form.hidePreviousStops}
                            onChange={() => this.props.onChangeCheckboxValue("hidePreviousStops")}>
                            Esconder paragens anterior à paragem alvo
                        </Checkbox>
                        <Checkbox className="margin-left-15"
                            checked={form.shrinkText}
                            onChange={() => this.props.onChangeCheckboxValue("shrinkText")}>
                            Ajustar tamanho do texto no caso de não caber nas dimensões especificadas
                        </Checkbox>
                    </FormGroup>
                </Grid >

                <ControlLabel className="margin-top-15">Opções</ControlLabel>
                <Grid fluid>
                    <FormGroup className="margin-top--10">
                        <Checkbox className="margin-left-15"
                            checked={form.hideZoneLimitStops}
                            onChange={() => this.props.onChangeCheckboxValue("hideZoneLimitStops")}>
                            Permitir esconder paragens limites de zona
                        </Checkbox>
                        <Checkbox className="margin-left-15"
                            checked={form.hideStopsWithMapPoint}
                            onChange={() => this.props.onChangeCheckboxValue("hideStopsWithMapPoint")}>
                            Permitir esconder paragens que pertençam a um ponto notável
                        </Checkbox>
                        <Checkbox className="margin-left-15"
                            checked={form.addSpacerStops}
                            onChange={() => this.props.onChangeCheckboxValue("addSpacerStops")}>
                            Adicionar espaçamento após 1ª paragem e antes da última paragem
                        </Checkbox>
                        <Checkbox className="margin-left-15"
                            checked={form.highlightComplementaryTerminals}
                            onChange={() => this.props.onChangeCheckboxValue("highlightComplementaryTerminals")}>
                            Destacar terminais após o percurso principal
                        </Checkbox>
                        <Checkbox className="margin-left-15"
                            checked={form.stretchSpine}
                            onChange={() => this.props.onChangeCheckboxValue("stretchSpine")}>
                            Esticar a espinha para preencher espaço em branco
                        </Checkbox>
                    </FormGroup>
                </Grid>

                <ControlLabel className="margin-top-15">Apresentação do Nome da Paragem</ControlLabel>
                <Grid fluid>
                    <FormGroup className="margin-top--10">

                        <Checkbox checked={form.showStopCaps}
                            onChange={() => this.props.onChangeCheckboxValue("showStopCaps")}>
                            Apresentar Paragens em Maiúsculas
                        </Checkbox>

                        <Checkbox checked={form.showStopCode}
                            onChange={() => this.props.onChangeCheckboxValue("showStopCode")}>
                            Mostrar Código da Paragem
                        </Checkbox>
                    </FormGroup>

                    {this.renderStopCodePrecedentAndSubsequentTextForm(form)}
                </Grid>

                <ControlLabel className="margin-top-15">Apresentação do Nome da Paragem</ControlLabel>
                <Grid fluid>
                    <FormGroup className="margin-top--10">
                        <Checkbox checked={form.showDescriptionOutsideSpine}
                            onChange={() => this.props.onChangeCheckboxValue("showDescriptionOutsideSpine")}>
                            Apresentar Descrição Para Paragens Fora do Percurso
                        </Checkbox>

                        <InputGroup>
                            <FormControl
                                style={{ flex: 1 }}
                                type="text"
                                placeholder="Inserir descrição"
                                value={form.descriptionOutsideSpine}
                                onChange={(e) => this.props.onChangeValue(e, "descriptionOutsideSpine")}
                                disabled={!form.showDescriptionOutsideSpine}
                            />

                            <InputGroup.Button>
                                <Button
                                    onClick={() => this.handleDescriptionOptionsClick()}
                                    disabled={!form.showDescriptionOutsideSpine}
                                >
                                    OPÇÕES
                                </Button>
                            </InputGroup.Button>
                        </InputGroup>
                    </FormGroup>
                </Grid>
            </div>
        );
    }

    renderStopCodePrecedentAndSubsequentTextForm(form) {
        if (!form.showStopCode) {
            return null;
        }

        return (
            <Grid fluid>
                <FormGroup className="margin-top--10 margin-left-30">
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                        <ControlLabel style={{ width: "280px", marginRight: "10px", whiteSpace: "nowrap" }}>
                            Texto Precedente ao Código da Paragem:
                        </ControlLabel>
                        <FormControl
                            style={{ flex: 1 }}
                            type="text"
                            placeholder="Inserir texto..."
                            value={form.stopCodePrecendentText}
                            onChange={(e) => this.props.onChangeValue(e, "stopCodePrecendentText")}
                        />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <ControlLabel style={{ width: "280px", marginRight: "10px", whiteSpace: "nowrap" }}>
                            Texto Subsequente ao Código da Paragem:
                        </ControlLabel>
                        <FormControl
                            style={{ flex: 1 }}
                            type="text"
                            placeholder="Inserir texto..."
                            value={form.stopCodeSubsequentText}
                            onChange={(e) => this.props.onChangeValue(e, "stopCodeSubsequentText")}
                        />
                    </div>
                </FormGroup>
            </Grid>

        );
    }

    renderNumberInput(label, placeholder, value, controlId, min, max, onChange) {
        return (
            <FormGroup controlId={controlId}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    type="number"
                    min={min}
                    max={max}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
            </FormGroup>
        );
    }

    renderBarsLayouts(barBuilderComponent, target, innerText, layoutsToRender = [0, 1, 2, 3, 4]) {
        const layoutsArray = Array.isArray(layoutsToRender)
            ? layoutsToRender
            : Array.from({ length: layoutsToRender }, (_, i) => i);

        const firstText = String((innerText && innerText['first']) ? innerText['first'] : '');
        const secondText = String((innerText && innerText['second']) ? innerText['second'] : '');

        const renderLayout0 = (
            <React.Fragment>
                <Rect x={12.5} y={20} width={115} height={20} strokeWidth={1} stroke="black" fill="#FFFFFF" />
                <Rect x={132.5} y={20} width={115} height={20} strokeWidth={1} stroke="black" fill="#FFFFFF" />
                <Text text={firstText} fontSize={14} x={50} y={25} />
                <Text text={secondText} fontSize={14} x={170} y={25} />
            </React.Fragment>
        );

        const renderLayout1 = (
            <React.Fragment>
                <Line x={15} y={20} points={[0, 0, 0, 20]} stroke="black" strokeWidth={1} />
                <Line x={15} y={40} points={[0, 0, 113, 0]} stroke="black" strokeWidth={1} />
                <Line x={132} y={20} points={[0, 0, 0, 20]} stroke="black" strokeWidth={1} />
                <Line x={132} y={40} points={[0, 0, 113, 0]} stroke="black" strokeWidth={1} />
                <Text text={firstText} fontSize={14} x={55} y={25} />
                <Text text={secondText} fontSize={14} x={170} y={25} />
            </React.Fragment>
        );

        const renderLayout2 = (
            <React.Fragment>
                <Rect x={15} y={20} width={115} height={20} strokeWidth={1} stroke="black" fill="#FFFFFF" />
                <Rect x={130} y={20} width={115} height={20} strokeWidth={1} stroke="black" fill="#FFFFFF" />
                <Text text={firstText.replace('min', '')} fontSize={14} x={55} y={25} rotation={90} offsetX={4} offsetY={20} />
                <Text text={secondText.replace('min', '')} fontSize={14} x={170} y={25} rotation={90} offsetX={4} offsetY={20} />
            </React.Fragment>
        );

        const renderLayout3 = (
            <React.Fragment>
                <Line x={15} y={20} points={[0, 0, 0, 20]} stroke="black" strokeWidth={1} />
                <Line x={15} y={40} points={[0, 0, 113, 0]} stroke="black" strokeWidth={1} />
                <Line x={128} y={20} points={[0, 0, 0, 20]} stroke="black" strokeWidth={1} />
                <Line x={132} y={20} points={[0, 0, 0, 20]} stroke="black" strokeWidth={1} />
                <Line x={132} y={40} points={[0, 0, 113, 0]} stroke="black" strokeWidth={1} />
                <Line x={245} y={20} points={[0, 0, 0, 20]} stroke="black" strokeWidth={1} />
                <Text text={firstText} fontSize={14} x={55} y={25} />
                <Text text={secondText} fontSize={14} x={170} y={25} />
            </React.Fragment>
        );

        const renderLayout4 = (
            <React.Fragment>
                <Line x={130} y={20} points={[0, 0, 0, 20]} stroke="black" strokeWidth={1} />
                <Line x={245} y={20} points={[0, 0, 0, 20]} stroke="black" strokeWidth={1} />
                <Text text={innerText['first']} fontSize={14} x={55} y={25} />
                <Text text={innerText['second']} fontSize={14} x={170} y={25} />
            </React.Fragment>
        );

        const layoutMap = {
            0: renderLayout0,
            1: renderLayout1,
            2: renderLayout2,
            3: renderLayout3,
            4: renderLayout4
        };

        const layouts = layoutsArray.map((i) => {
            const isSelected = barBuilderComponent === i;

            return (
                <Col key={i} md={4} sm={6} xs={12}>
                    <Stage width={260} height={60} style={{ cursor: "pointer" }}>
                        <Layer>
                            <Group onClick={() => this.props.onChangeSelectValue(i, target)}>
                                <Rect
                                    x={5}
                                    y={5}
                                    width={250}
                                    height={50}
                                    strokeWidth={isSelected ? 3 : 1}
                                    stroke={isSelected ? "#6699ff" : "#4d4d4d"}
                                    fill="#FFFFFF"
                                />
                                {layoutMap[i]}
                            </Group>
                        </Layer>
                    </Stage>
                </Col>
            );
        });

        return (
            <Grid fluid>
                <Row>{layouts}</Row>
            </Grid>
        );
    }

    renderDurationBarConfigurationsForm(form) {
        return (
            <FormGroup>
                <Checkbox
                    checked={form.showDurations !== false}
                    onChange={() => this.props.onChangeCheckboxValue('showDurations')}
                >
                    Apresentar durações
                </Checkbox>
                {form.showDurations !== false && (
                    <div>
                        <ControlLabel className="margin-top-15">Barra da Duração</ControlLabel>
                        {this.renderBarsLayouts(
                            form.durationBackgroundBuilderComponent,
                            "durationBackgroundBuilderComponent",
                            { 'first': '10min', 'second': '15min' },
                            [0, 1, 2, 4]
                        )}
                    </div>
                )}
            </FormGroup>
        );
    }

    renderZonesBarConfigurationsForm(form) {
        const zonesConfig = form.zonesConfig;
        const allZones = this.state.allZones;

        return (
            <FormGroup>
                <div className="margin-bottom-15">
                    <ControlLabel className="margin-top-15">Barra da Zona</ControlLabel>
                    {this.renderBarsLayouts(
                        form.zonesConfig.zonesBackgroundBuilderComponent,
                        "zonesConfig.zonesBackgroundBuilderComponent",
                        { 'first': 'Zona A', 'second': 'Zona B' },
                        form.zonesConfig.zonesPosition === "left" ? [0, 1, 4] : [0, 1, 3, 4]
                    )}
                </div>
                <div>
                    <ControlLabel>Posição das zonas em relação à espinha</ControlLabel>
                    <Grid fluid>
                        <FormGroup className="margin-top--10">
                            <Radio
                                name="zonesPosition"
                                checked={zonesConfig.zonesPosition === "left"}
                                onChange={() => this.handleZonesPositionChange("left")}
                            >
                                Esquerda
                            </Radio>
                            <Radio
                                name="zonesPosition"
                                checked={zonesConfig.zonesPosition === "right"}
                                onChange={() => this.handleZonesPositionChange("right")}
                            >
                                Direita
                            </Radio>
                        </FormGroup>
                    </Grid>
                </div>
                <div>
                    <Grid fluid>
                        <FormGroup className="margin-top-15">
                            <ControlLabel className="margin-left--15">Zonas a excluir</ControlLabel>
                            <Select
                                styles={{ container: (base) => ({ ...base, width: 600 }) }}
                                className="custom-multiselect"
                                placeholder="Selecione as Zonas..."
                                noOptionsMessage={() => "Sem Regiões Configuradas"}
                                onChange={(e) => this.handleZoneExclusionsChange(e)}
                                options={allZones}
                                isMulti={true}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.name}
                                value={allZones.filter(zone => !form.zonesConfig.zones.some(z => z.id === zone.id))}
                            />
                        </FormGroup>
                    </Grid>
                </div>
            </FormGroup>
        );
    }

    renderPointerImage(form) {
        const { isLoading, isSaving, isDeleting } = this.state.actions;
        if (isLoading || isSaving || isDeleting) {
            return (
                <LoadingSpinner />
            );
        }

        const selectedData = `${this.props.selectedData}`;

        const { formData, styles, table } = this.state;
        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <div className="margin-bottom-10">
                <ControlLabel className="margin-top-15">Adicionar apontador na paragem atual</ControlLabel>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th>Imagem Apontador</th>
                                        <th style={{ whiteSpace: "unset" }}>Rotação [-360..360]</th>
                                        <th style={{ whiteSpace: "unset" }}>Opacidade [0..1]</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        partialData.map((obj, idx) =>
                                            <tr key={`data-${idx}`}>
                                                <td style={{ whiteSpace: "unset" }}><a target="_blank" rel="noopener noreferrer" href={obj.url}>{undefined === obj.url ? "" : obj.url.split('/').slice(-1)}</a></td>
                                                <td>{obj.rotationAngle}&deg;</td>
                                                <td>{obj.opacity}</td>
                                                <td>{this.selectedData(obj)}</td>
                                                <td><TableButton disabled={`${obj.id}` === selectedData} icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteData(obj)} /></td>
                                            </tr>
                                        )
                                    }
                                    <tr>
                                        <td>
                                            <FormGroup controlId="formDataUrl"
                                                className="margin-bottom-0"
                                                validationState={styles.url} >
                                                <input
                                                    type="file"
                                                    ref="imageUploader"
                                                    accept="image/*"
                                                    style={{ display: "none" }}
                                                    onChange={(a) => this.onChangeFile(a)} />
                                                <InputGroup bsSize="small">
                                                    <FormControl
                                                        type="text"
                                                        placeholder="URL"
                                                        value={formData.url}
                                                        onChange={(e) => this.onChangeValue(e, 'url')} />
                                                    <InputGroup.Button>
                                                        <Button onClick={() => this.onFileUploadButtonClick()}>Imagem</Button>
                                                    </InputGroup.Button>
                                                </InputGroup>
                                                <HelpBlock>{null === formData.file ? "Inserido URL" : "Carregada Imagem"}</HelpBlock>
                                            </ FormGroup>
                                        </td>
                                        <td className="cell-align-top">
                                            <FormGroup bsSize="small"
                                                controlId="formDataRotationAngle"
                                                className="margin-bottom-0"
                                                validationState={styles.rotationAngle} >
                                                <FormControl
                                                    type="number"
                                                    step={0.1}
                                                    min={-360}
                                                    max={360}
                                                    placeholder="Ângulo de Rotação"
                                                    value={formData.rotationAngle}
                                                    onChange={(e) => this.onChangeValue(e, 'rotationAngle')} />
                                            </ FormGroup>
                                        </td>
                                        <td className="cell-align-top">
                                            <FormGroup bsSize="small"
                                                controlId="formDataOpacity"
                                                className="margin-bottom-0"
                                                validationState={styles.opacity} >
                                                <FormControl
                                                    type="number"
                                                    step={0.1}
                                                    min={0}
                                                    max={1}
                                                    placeholder="Opacidade"
                                                    value={formData.opacity}
                                                    onChange={(e) => this.onChangeValue(e, 'opacity')} />
                                            </ FormGroup>
                                        </td>
                                        <td className="cell-align-top" colSpan={2}>
                                            <ButtonToolbar>
                                                <TableButton className="no-padding-top" icon="icon-plus" title="Adicionar" onClick={() => this.onAddData()} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            <PaginationBuilder
                                currentPage={table.page}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={table.data.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                        </Col>
                    </Row>
                </Grid>

                <ControlLabel>Posição da imagem da paragem atual</ControlLabel>
                <Grid fluid>
                    <FormGroup className="margin-top--10">
                        <Radio
                            name="imageOrientation"
                            checked={form.imageOrientation === "left"}
                            onChange={() => this.props.onChangeRadio("imageOrientation", "left")}
                        >
                            À esquerda da espinha
                        </Radio>
                        <Radio
                            name="imageOrientation"
                            checked={form.imageOrientation === "right"}
                            onChange={() => this.props.onChangeRadio("imageOrientation", "right")}
                        >
                            À direita da espinha
                        </Radio>
                    </FormGroup>
                </Grid>
            </div>
        );
    }

    renderPathOptions(form) {
        return (
            <div>
                <FormGroup className="margin-top-15">
                    <ControlLabel>Configuração da Descrição</ControlLabel>
                    <Grid fluid>
                        <FormGroup className="margin-top--10">
                            <Checkbox
                                checked={form.showPathsDescription}
                                onChange={() => this.props.onChangeCheckboxValue("showPathsDescription")}>
                                Exibir a descrição dos percursos na espinha
                            </Checkbox>
                        </FormGroup>
                    </Grid>
                </FormGroup>
            </div>
        );
    }

    renderInterfacesOptions(form) {
        const resizeFactor = Number.isFinite(form.interfaceResizeFactor)
            ? form.interfaceResizeFactor
            : 1.0;

        return (
            <div>
                <FormGroup className="margin-top-15">
                    <ControlLabel>Gestão de Interfaces</ControlLabel>
                    <Grid fluid>
                        <FormGroup className="margin-top--10">
                            <Checkbox
                                checked={form.showInterfacesInSpine}
                                onChange={() => this.props.onChangeCheckboxValue("showInterfacesInSpine")}>
                                Mostrar interfaces na espinha
                            </Checkbox>
                        </FormGroup>
                    </Grid>
                </FormGroup>

                <FormGroup className="margin-top-15">
                    <ControlLabel>Modo de apresentação das interfaces</ControlLabel>
                    <Grid fluid>
                        <FormGroup className="margin-top--10">
                            <Radio
                                name="interfaceOption"
                                checked={form.interfaceOption === "stop"}
                                onChange={() => this.props.onChangeRadio("interfaceOption", "stop")}>
                                Apenas Paragem
                            </Radio>
                            <Radio
                                name="interfaceOption"
                                checked={form.interfaceOption === "mapPoint"}
                                onChange={() => this.props.onChangeRadio("interfaceOption", "mapPoint")}>
                                Apenas Ponto Notável
                            </Radio>
                            <Radio
                                name="interfaceOption"
                                checked={form.interfaceOption === "all"}
                                onChange={() => this.props.onChangeRadio("interfaceOption", "all")}>
                                Ambos
                            </Radio>
                        </FormGroup>
                    </Grid>

                    <FormGroup className="margin-top-15">
                        <ControlLabel>Definições da Imagem</ControlLabel>
                        <Grid fluid className="margin-left--15">
                            <Row style={{ display: 'flex', gap: '40px', alignItems: 'left' }}>
                                <Col style={{ display: 'flex', alignItems: 'center', marginLeft: '-30px' }}>
                                    <Label className="clean-label">Ângulo rotação:</Label>
                                    <FormControl
                                        className="margin-left-15"
                                        style={{ width: "75px" }}
                                        type="number"
                                        step={0.1}
                                        min={-360}
                                        max={360}
                                        placeholder="-360..360"
                                        value={form.interfaceRotationAngle}
                                        onChange={(e) =>
                                            this.props.onChangeValue(
                                                { target: { value: parseFloat(e.target.value) } },
                                                'interfaceRotationAngle'
                                            )
                                        }
                                    />
                                </Col>

                                <Col style={{ display: 'flex', alignItems: 'center' }}>
                                    <Label className="clean-label">Fator de dimensionamento:</Label>
                                    <FormControl
                                        className="margin-left-15 resize-factor-input"
                                        style={{ width: "75px" }}
                                        type="number"
                                        step={0.1}
                                        min={0}
                                        max={5}
                                        placeholder="0.0 → 5.0"
                                        value={resizeFactor}
                                        onChange={(e) => {
                                            this.props.onChangeValue(
                                                { target: { value: parseFloat(e.target.value) } },
                                                'interfaceResizeFactor'
                                            );
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Grid>
                    </FormGroup>
                </FormGroup>
            </div>
        );
    }

    renderTabs(form) {
        return (
            <div style={{ marginBottom: "15px" }}>
                <Tabs id="config-tabs">
                    <Tab eventKey={1} title="Paragens" style={{ marginTop: "15px" }}>
                        <Grid fluid>
                            <Row>
                                <Col md={12}>
                                    {this.renderStopTextConfigurationsForm(form)}
                                </Col>
                            </Row>
                        </Grid>
                    </Tab>

                    <Tab eventKey={2} title="Duração" style={{ marginTop: "15px" }}>
                        <Grid fluid>
                            <Row>
                                <Col md={12}>
                                    {this.renderDurationBarConfigurationsForm(form)}
                                </Col>
                            </Row>
                        </Grid>
                    </Tab>

                    <Tab eventKey={3} title="Zonas" style={{ marginTop: "15px" }}>
                        <Grid fluid>
                            <Row>
                                <Col md={12}>
                                    {this.renderZonesBarConfigurationsForm(form)}
                                </Col>
                            </Row>
                        </Grid>
                    </Tab>

                    <Tab eventKey={4} title="Interfaces" style={{ marginTop: "15px" }}>
                        <Grid fluid>
                            <Row>
                                <Col md={12}>
                                    {this.renderInterfacesOptions(form)}
                                </Col>
                            </Row>
                        </Grid>
                    </Tab>

                    <Tab eventKey={5} title="Apontador" style={{ marginTop: "15px" }}>
                        <Grid fluid>
                            <Row>
                                <Col md={12}>
                                    {this.renderPointerImage(form)}
                                </Col>
                            </Row>
                        </Grid>
                    </Tab>
                    <Tab eventKey={6} title="Percursos" style={{ marginTop: "15px" }}>
                        <Grid fluid>
                            <Row>
                                <Col md={12}>
                                    {this.renderPathOptions(form)}
                                </Col>
                            </Row>
                        </Grid>
                    </Tab>
                </Tabs>
            </div>
        );
    }

    render() {
        const { form } = this.props;
        const { message, dialog, descriptionOptions } = this.state;

        return (
            <div>
                {this.renderTabs(form)}

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={this.props.onFinishSelectData}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={this.props.onCancel}>CANCELAR</Button>
                </ButtonToolbar>

                <TextOptionsPickerModal
                    options={descriptionOptions.options}
                    show={descriptionOptions.show}
                    onHide={() => this.onExitDescriptionOptions()}
                    onSelect={(a) => this.onSelectDescriptionOption(a)} />

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}

